import ItemMixin from './ItemMixin'

export default {
    mixins: [
        ItemMixin
    ]
}